import { combineReducers } from 'redux';
import barcodeScannerModal from './reducer_oms_barcode_scan_modal';
import loadingReducer from './reducer_oms_loading';
import omsReducerControlRecords from './reducer_oms_control_records';
import packShipReducer from './reducer_oms_pack';
import pickReducer from './reducer_oms_pick';
import printingReducer from './reducer_oms_printing';
import selectedReducer from './reducer_oms_selected';
import stickyReducer from './reducer_oms_sticky_state';

const selected = combineReducers({
  initial: selectedReducer('@oms/INITIAL'),
  pick: selectedReducer('@oms/PICK'),
  pack_ship: selectedReducer('@oms/PACKSHIP'),
});

const modal = combineReducers({
  barcode_scanner: barcodeScannerModal,
});

export const omsReducer = combineReducers({
  selected,
  modal,
  list: omsReducerControlRecords,
  loading: loadingReducer,
  pack_ship: packShipReducer,
  pick: pickReducer,
  printing: printingReducer,
  sticky: stickyReducer,
});
